import { debounce } from 'lodash';
import { ChangeEvent, useCallback } from 'react';
import { FiSearch } from 'react-icons/fi';

import Button from '../../../components/Button';
import { PintoEbookSubmissionStatus } from '../../../core/graphql/types';

interface IStatusOption {
  label: string;
  value: PintoEbookSubmissionStatus | null;
}

interface IPropsEbookSubmissionFilterPresenter {
  status: PintoEbookSubmissionStatus | null;
  statusOptions?: IStatusOption[];
  onSetStatus: (status: PintoEbookSubmissionStatus | null) => void;
  onSetSearchText: (text?: string) => void;
}

const EbookSubmissionFilterPresenter = ({ status, statusOptions, onSetStatus, onSetSearchText }: IPropsEbookSubmissionFilterPresenter) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onChangeKeyWord = useCallback(
    debounce((e: ChangeEvent<HTMLInputElement>) => {
      onSetSearchText(e.target.value);
    }, 500),
    [],
  );

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-12">
        <div className="text-systemGrays02LabelSecondary">Status: </div>
        <div className="space-x-4">
          {statusOptions?.map((option) => (
            <Button
              round
              type={option.value === status ? 'fill' : 'outline'}
              key={option.value || 'all'}
              color={option.value === status ? 'red' : 'gray'}
              onClick={() => onSetStatus(option.value)}
              className="h-[40px]"
            >
              {option.label?.toLocaleUpperCase()}
            </Button>
          ))}
        </div>
      </div>

      <div className="relative">
        <FiSearch className="absolute top-[16px] left-[12px] text-colorsBrandWarmBlack02LabelSecondary text-18" />
        <input type="text" placeholder="search admin note" className="w-[300px] pl-36 input" onChange={onChangeKeyWord} />
      </div>
    </div>
  );
};

export default EbookSubmissionFilterPresenter;
